import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';


const LazyCategoriesContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "Categories" */
    './Container'
  ),
  loading: () => null
});

const CategoriesRoute = (
  <Route
    key="Categories"
    path="/categories/:tagValue/"
    component={LazyCategoriesContainer}
  />
);

export default CategoriesRoute;
